module.exports = __webpack_public_path__ + "static/Gallery-5-190b73ade127cd7acdb73ef079d9e0fa.jpg";